// Wrapper function for Object.entries with specific type annotations
export const typedEntries = <
  T extends Partial<Record<K, V>>,
  K extends keyof T = keyof T,
  V = T[K]
>(
  obj: T
): [K, V][] => {
  return Object.entries(obj) as [K, V][];
};

// Example usage
const myObject = { a: 1, b: 'hello', c: true };
const entries = typedEntries(myObject);

// Now 'entries' has the type: Array<[keyof typeof myObject, typeof myObject[keyof typeof myObject]]>
